module.exports = __webpack_public_path__ + "img/landing.3b77f5bd.svg";